<template>
  <div v-if="room && room.profile" class="info-wrapper-box">
    <a href="#" @click.prevent="onClick">
      <div
        v-if="room.avatar"
        class="room-avatar"
        :style="{ 'background-image': `url('${room.avatar}?p=tiny')` }"
      >
        <div v-if="room.profile.is_online" class="avatar-single__online-status"></div>
      </div>
    </a>
    <div>
      <a href="#" @click.prevent="onClick">
        <div class="room-name">{{ room.roomName }}</div>
        <div class="room-info" v-if="room.profile.is_online">{{ trans.get('pages:chat.is_online_now') }}</div>
        <div class="room-info" v-else>{{ trans.get('pages:chat.is_offline') }}</div>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RoomInfo',
  components: {},
  props: {
    room: {},
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    onClick() {
      if (this.room.profile.is_blurred_avatar) {
        this.$eventHub.$emit('BuyProfileModalOpen', { profileId: this.room.profile.id, form: { distance: 500 }, avatarUrl: this.room.avatar });
      } else {
        this.$router.push({ name: 'profile', params: { id: this.room.profile_id } });
      }
    },
  },
  watch: {},
  mounted() {
  }
};
</script>
